module.exports = __webpack_public_path__ + "img/guide.7f59c457.png";